import PriceForecastRoute from './subpages/price-forecast/route'
import RecommendationsRoute from './subpages/recommendations/route'
import ScenariosRoute from './subpages/scenarios/route'
import RenewalProposalRoute from './subpages/renewal-proposal/route'

export default {
  path: 'predictions',
  meta: { requiresAuth: true },
  component: () => import(/* webpackChunkName: "financial-predictions" */ './Predictions'),
  redirect: '/financial/predictions/scenarios',
  children: [PriceForecastRoute, RecommendationsRoute, ScenariosRoute, RenewalProposalRoute]
}
